import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faImages,
  faBars,
  faTimes,
  faDashboard,
  faTableList,
  faFolderClosed,
  faArrowLeft,
  faKey,
  faEyeSlash,
  faEye,
  faUsers,
  faHourglassStart,
  faArrowRightArrowLeft,faMoon, faSun,
  faUsersBetweenLines
} from '@fortawesome/free-solid-svg-icons';
import { IoMdNotifications } from "react-icons/io";
import { ImProfile } from "react-icons/im";
import { SlSupport } from "react-icons/sl";
import { FaMobileAlt } from "react-icons/fa";
import SiteTreeView from './SiteTreeView';
import './../styles/NavigationBar.css';
import { useAuth } from './../context/AuthContext';
import { useSite } from './../context/SiteContext';
import { useFilterContext } from './../context/FilterContext';
import { useUIContext } from './../context/UIContext';
import ResetPasswordModal from './modals/ResetPasswordModal';
import esafeLogo from './../assets/images/favicon.ico';
import {useSidebar}  from './../context/SidebarContext';
import './../styles/NotificationPage.css';
import { useTheme } from "./../hooks/useTheme";
import { UserType } from './../constants/userType';

function NavigationBar() {
  const navigate = useNavigate();
  const { logout, userType } = useAuth();
  const { setSelectedSiteId } = useSite();
  const { isExpanded, toggleSidebar, setIsExpanded } = useSidebar();
  const { resetFilters } = useFilterContext();
  const { isBlurred, toggleBlur } = useUIContext();
  const [showPwdModal, setShowPwdModal] = useState(false);
  const handleLogout = () => {
    logout();
    resetFilters();
    navigate(`/login`);
  };
const { theme, setTheme } = useTheme();
const [themeOpen, setThemeOpen] = useState(false);
const themeRef = useRef(null);
  const toggleMenu = toggleSidebar;

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (userType === UserType.POLICE) {
      setIsExpanded(true);
    }
  }, [userType, setIsExpanded]);

  useEffect(() => {
  const onDocClick = (e) => {
    if (!themeRef.current) return;
    if (!themeRef.current.contains(e.target)) setThemeOpen(false);
  };
  document.addEventListener("mousedown", onDocClick);
  return () => document.removeEventListener("mousedown", onDocClick);
}, []);
useEffect(() => {
  const onKeyDown = (e) => {
    if (e.key === "Escape") setThemeOpen(false);
  };
  document.addEventListener("keydown", onKeyDown);
  return () => document.removeEventListener("keydown", onKeyDown);
}, []);
  return (
    <div className="navigation-container">
      <aside className={`vertical-menu ${isExpanded ? 'expanded' : 'collapsed'}`}>
        <Link
          onClick={toggleMenu}
          className="menu-toggle"
          aria-label={isExpanded ? 'Collapse navigation' : 'Expand navigation'}
          aria-expanded={isExpanded}
        >
          <FontAwesomeIcon icon={isExpanded ? faTimes : faBars} />
        </Link>
        <div className="menu-inner">
          <div className="menu-scroll">
            <ul className="navg-menu-left">
              <li>
                <NavLink
                  onClick={handleBack}                  
                  className='navg-link'                  
                  data-tooltip="Back"
                >
                  <FontAwesomeIcon icon={faArrowLeft} className="navg-icon" />
                  {isExpanded && 'Back'}
                </NavLink>
              </li>
              {(userType === UserType.SUPER || userType === UserType.SUPPORT) && (
                <li>
                  <NavLink
                    to="/support-dashboard/device-telemetry"
                    className={({ isActive }) =>
                      isActive ? 'navg-link active-navg-link' : 'navg-link'
                    }
                    data-tooltip="Device Telemetry"
                  >
                    <FaMobileAlt className="navg-icon" />
                    {isExpanded && 'Device Telemetry'}
                  </NavLink>
                </li>
              )}
              {(userType === UserType.SUPER || userType === UserType.SUPPORT) && (
                <li>
                  <NavLink
                    to="/support-dashboard"
                    end
                    className={({ isActive }) =>
                      isActive ? 'navg-link active-navg-link' : 'navg-link'
                    }
                    data-tooltip="Support"
                  >
                    <SlSupport className="navg-icon" />
                    {isExpanded && 'Support'}
                  </NavLink>
                </li>
              )}
              {(userType === UserType.SUPER || userType === UserType.TEAMLEADER) && (
                <li>
                  <NavLink
                    to="/dashboard"
                    className={({ isActive }) =>
                      isActive ? 'navg-link active-navg-link' : 'navg-link'
                    }
                    data-tooltip="Dashboard"
                  >
                    <FontAwesomeIcon icon={faDashboard} className="navg-icon" />
                    {isExpanded && 'Dashboard'}
                  </NavLink>
                </li>
              )}
              {userType === UserType.POLICE && (
                <li>
                  <NavLink
                    to="/notifications"
                    className={({ isActive }) =>
                      (isActive ? 'navg-link-noti active-navg-link-noti' : 'navg-link-noti') + ' has-badge'
                    }
                    data-tooltip="Notifications"
                  >
                    <div className="navg-icon-wrapper-noti">
                      <IoMdNotifications className="navg-icon-noti" />
                    </div>
                    {isExpanded && 'Notifications'}
                  </NavLink>
                </li>
              )}
              <li>
                <NavLink
                  to="/images"
                  className={({ isActive }) =>
                    isActive ? 'navg-link active-navg-link' : 'navg-link'
                  }
                  data-tooltip="Images"
                >
                  <FontAwesomeIcon icon={faImages} className="navg-icon" />
                  {isExpanded && 'Images'}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/incidents"
                  className={({ isActive }) =>
                    isActive ? 'navg-link active-navg-link' : 'navg-link'
                  }
                  data-tooltip="Incidents"
                >
                  <FontAwesomeIcon icon={faTableList} className="navg-icon" />
                  {isExpanded && 'Incidents'}
                </NavLink>
              </li>
              {(userType === UserType.SUPER || userType === UserType.TEAMLEADER) && (
              <li>
                <NavLink
                  to="/Analysts"
                  className={({ isActive }) =>
                    isActive ? 'navg-link active-navg-link' : 'navg-link'
                  }
                  data-tooltip="Analysts"
                >
                  <FontAwesomeIcon icon={faUsersBetweenLines} className="navg-icon" size={24}/>
                  {isExpanded && 'Analysts'}
                </NavLink>
              </li>
              )}
              <li>
                <NavLink
                  to="/users"
                  className={({ isActive }) =>
                    isActive ? 'navg-link active-navg-link' : 'navg-link'
                  }
                  data-tooltip="Users"
                >
                  <FontAwesomeIcon icon={faUsers} className="navg-icon" />
                  {isExpanded && 'Users'}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/pending-activation"
                  className={({ isActive }) =>
                    isActive ? 'navg-link active-navg-link' : 'navg-link'
                  }
                  data-tooltip="Pending Activation"
                >
                <FontAwesomeIcon icon={faHourglassStart} className="navg-icon" />
                  {isExpanded && 'Pending Activation'}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/reports"
                  className={({ isActive }) =>
                    isActive ? 'navg-link active-navg-link' : 'navg-link'
                  }
                  data-tooltip="Reports"
                >
                  <FontAwesomeIcon icon={faFolderClosed} className="navg-icon" />
                  {isExpanded && 'Reports'}
                </NavLink>
              </li>
                {(userType !== UserType.POLICE) && (
              <li>
                <NavLink
                  to="/transfers-users"
                  className={({ isActive }) =>
                    isActive ? 'navg-link active-navg-link' : 'navg-link'
                  }
                  data-tooltip="Transfers"
                >
                  <FontAwesomeIcon icon={faArrowRightArrowLeft} className="navg-icon" />
                  {isExpanded && 'Transfers'}
                </NavLink>
              </li>
              )}
                 
               {(userType !== UserType.POLICE) && (
              <li>
                <NavLink
                  to="/profile"
                  className={({ isActive }) =>
                    isActive ? 'navg-link active-navg-link' : 'navg-link'
                  }
                  data-tooltip="Profile"
                >                  
                  <ImProfile className="navg-icon"/>
                  {isExpanded && 'Profile'}
                </NavLink>
              </li>
              )}
            </ul>
          </div>
        </div>
      </aside>

      <div className="navg-bar-container">
        <nav className="navg-bar">
          <div className="navg-bar-right">
            <div className="site-treeview-container">
              <SiteTreeView onSiteClick={setSelectedSiteId} />
            </div>
            <div className="navg-bar-button">
              <button onClick={toggleBlur} className="navg-button-blur">
                <FontAwesomeIcon icon={isBlurred ? faEyeSlash : faEye} />
                {isBlurred ? ' Unblur Images' : ' Blur Images'}
              </button>
              <div className="navg-theme-dropdown" ref={themeRef} data-tooltip="Profile">
                  <button
                    type="button"
                    className="navg-button-theme"
                    onClick={() => setThemeOpen(v => !v)}
                    aria-haspopup="menu"
                    aria-expanded={themeOpen}
                    title="Theme"
                  >
                    <FontAwesomeIcon icon={theme === "dark" ? faMoon : faSun} />
                  </button>

                  {themeOpen && (
                    <div className="navg-theme-menu" role="menu" aria-label="Theme">
                      <button
                        type="button"
                        className={`navg-theme-item ${theme === "light" ? "active" : ""}`}
                        role="menuitem"
                        onClick={() => { setTheme("light"); setThemeOpen(false); }}
                      >
                        <FontAwesomeIcon icon={faSun} /> Light
                      </button>

                      <button
                        type="button"
                        className={`navg-theme-item ${theme === "dark" ? "active" : ""}`}
                        role="menuitem"
                        onClick={() => { setTheme("dark"); setThemeOpen(false); }}
                      >
                        <FontAwesomeIcon icon={faMoon} /> Dark
                      </button>
                    </div>
                  )}
                </div>
              <button
                onClick={() => setShowPwdModal(true)}
                className="navg-button-change-pwd"
                title="Change Password"
              >
                <FontAwesomeIcon icon={faKey} /> Change Password
              </button>
              <button onClick={handleLogout} className="navg-button-logout">
                Sign Out
              </button>
              
                
            </div>
          </div>
          <div className="navg-bar-logo-container">
            <span className="navg-bar-logo">
              <span className="logo-base"> 
              <img src={esafeLogo} alt="eSafe Logo" className="logo-image" />
              </span>
              <span className="logo-extension">Monitor</span>
            </span>
          </div>
        </nav>
      </div>
      {showPwdModal && (
        <ResetPasswordModal onClose={() => setShowPwdModal(false)} />
      )}
    </div>
  );
}

export default NavigationBar;
